import { useApiBase } from "data/api/base";
import { ApiListModel } from "model/api/api-list-model/api-list-model";
import { TransferenciaListModel } from "model/api/gestao/transferencia/transferencia-list-model";
import { useCallback } from "react";
import { useSessaoAtual } from "services/app";
import { VariaveisAmbiente } from 'config';


export function useGetTransferencia() {
    const { invocarApi, ...outrasPropriedades } = useApiBase<ApiListModel<TransferenciaListModel>>();

    const { getEmpresa } = useSessaoAtual();

    const getTransferencia = useCallback(
        (query: string) =>
            invocarApi({
                method: 'GET',
                url: `/${VariaveisAmbiente.apiVersion}/Empresa/${getEmpresa().Id}/Transferencia?${query}`,
                headers: { 'Content-Type': 'application/json;charset=utf-8' },
                enviarTokenUsuario: true
            }),
        [getEmpresa, invocarApi]
    );
    return {
        ...outrasPropriedades,
        getTransferencia
    }

}